export default "__VITE_ASSET__BA517pXZ__"